import api from "PFCore/api";
import { Id } from "PFTypes";

export type FetchMatchingActivityStatusParams = {
  activityId: Id;
  profileId: Id;
};

export type FetchMatchingActivityStatusResponse = {
  needsRefresh: boolean;
};

export const fetchMatchingActivityStatus = ({
  activityId,
  profileId
}: FetchMatchingActivityStatusParams): Promise<FetchMatchingActivityStatusResponse> =>
  api({
    url: `matching_activities/${activityId}/status`,
    params: {
      profileId
    }
  });
